// pages/About.tsx — the product + its creator (spec §4.5). Source of truth: deb0.com.
import { Seo } from '../components/Seo';
import { Wordmark } from '../components/Wordmark';

const LINKS = [
  { href: 'https://deb0.com', label: 'deb0.com' },
  { href: 'https://www.linkedin.com/in/debajyotisaikia/', label: 'LinkedIn' },
  { href: 'https://github.com/DebajyotiSaikia', label: 'GitHub' },
  { href: 'https://blog.deb0.com/', label: 'Blog' },
];

const JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Debajyoti Saikia',
  jobTitle: 'Principal Software Engineer',
  worksFor: { '@type': 'Organization', name: 'Microsoft' },
  url: 'https://deb0.com',
  sameAs: [
    'https://www.linkedin.com/in/debajyotisaikia/',
    'https://github.com/DebajyotiSaikia',
    'https://blog.deb0.com/',
  ],
};

export function About() {
  return (
    <>
      <Seo
        title="About — UPLOAD"
        description="UPLOAD is built by Debajyoti Saikia, Principal Software Engineer at Microsoft."
        path="/about"
        jsonLd={JSON_LD}
      />
      <article className="mx-auto max-w-2xl py-16">
        <h1 className="text-3xl font-semibold">
          About <Wordmark className="text-2xl" />
        </h1>
        <p className="mt-6 opacity-80">
          <Wordmark className="text-base" /> is a work digital twin. It captures how you think and
          work so your own AI agents can later act as you — reasoning from your captured self, not
          simulating you from outside.
        </p>

        <h2 className="mt-10 text-2xl font-semibold">The creator</h2>
        <p className="mt-4 opacity-80">
          <Wordmark className="text-base" /> is created by <strong>Debajyoti Saikia</strong> —
          Principal Software Engineer at Microsoft. He builds AI-powered products spanning language
          learning, autonomous agents, manga creation, and travel planning.
        </p>
        <ul className="mt-6 flex flex-wrap gap-4">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a className="link" href={l.href} target="_blank" rel="noreferrer">
                {l.label}
              </a>
            </li>
          ))}
        </ul>
        <p className="mt-8 text-sm opacity-60">Source of truth: deb0.com.</p>
      </article>
    </>
  );
}
